import type { FunctionComponent } from 'react'

import type { SectionFragment } from '../../graphql/fragments/SectionFragment.graphql'
import { SectionOfContent } from '../section-of-content'

/**
 * Renders a section, styled for articles.
 */
export const ArticleSection: FunctionComponent<SectionFragment> = (props) => (
    <SectionOfContent padHorizontal={false} {...props} />
)
